  (function () {

      const footer = () => {
          const footerDetails = document.querySelectorAll(
              '.footer .accordion details',
          );

          footerDetails.forEach((targetDetail) => {
              const summary = targetDetail.querySelector('summary');
              const content = targetDetail.querySelector('.footer-block__details-content');
              if (!summary || !content) return;

              content.style.maxHeight = targetDetail.open ? content.scrollHeight + 'px' : '0';

              summary.addEventListener('click', (e) => {
                  e.preventDefault();

                  if (targetDetail.open) {
                      content.style.maxHeight = '0';
                      content.addEventListener('transitionend', function handler() {
                          targetDetail.open = false;
                          content.removeEventListener('transitionend', handler);
                      });
                  } else {
                      // Diğerlerini kapat
                      footerDetails.forEach((detail) => {
                          if (detail !== targetDetail && detail.open) {
                              const otherContent = detail.querySelector('.footer-block__details-content');
                              if (otherContent) {
                                  otherContent.style.maxHeight = '0';
                                  otherContent.addEventListener('transitionend', function handler() {
                                      detail.open = false;
                                      otherContent.removeEventListener('transitionend', handler);
                                  });
                              }
                          }
                      });

                      targetDetail.open = true;
                      requestAnimationFrame(() => {
                          content.style.maxHeight = content.scrollHeight + 'px';
                      });
                  }
              });
          });

          function updateButtonState() {
              const isEmailValid = emailRegex.test(emailInput.value);
              const isChecked = checkboxInput.checked;

              if (isEmailValid && isChecked) {
                  newsletterButton.classList.remove('disabled');
                  newsletterButton.disabled = false;
              } else {
                  newsletterButton.classList.add('disabled');
                  newsletterButton.disabled = true;
              }
          }

          const emailInput = document.querySelector('[data-footer-newsletter-input]');
          const newsletterButton = document.querySelector('[data-footer-newsletter-button]');
          const checkboxInput = document.querySelector('[data-footer-newsletter-checkbox]');
          const checkboxWrapper = document.querySelector(".newsletter-form_checkbox_message");
          const emailRegex = /^[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$/;

          newsletterButton.classList.add('disabled');
          newsletterButton.disabled = true;

          emailInput.addEventListener('input', () => {
              if (emailRegex.test(emailInput.value)) {
                  checkboxWrapper.classList.add('active');
              } else {
                  checkboxWrapper.classList.remove('active');
              }
              updateButtonState();
          });

          checkboxInput.addEventListener('change', () => {
              updateButtonState();
          });
      }

      document.addEventListener('shopify:section:load', footer);
      footer();

  })();
